import UIContactSalesButton from '../../button/UIContactSalesButton';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const TalkToSalesButton = ({
  upgradeConfig,
  onOpen,
  onClose
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradeConfig);
  return /*#__PURE__*/_jsx(UIContactSalesButton, {
    use: "tertiary",
    isUpgradePoint: true,
    upgradeData: upgradeData,
    size: "small",
    onClick: onOpen,
    onCancel: onClose
  });
};
export default TalkToSalesButton;